module.exports = __webpack_public_path__ + "img/introduction_advert_02.4b9acf4d.jpg";